'use strict';
require('../../../modules/es.regexp.exec');
require('../../../modules/es.string.replace');
require('../../../modules/es.string.replace-all');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('String', 'replaceAll');
